<template>
    <TitleCommon :title="slug || `About Games`" />
    <div class="about__lotto" v-if="dataConfig">
        <template v-if="slug === ''">
            <template v-if="dataConfig?.skin === ABOUT_LIST_SKIN.NAV">
                <div class="about__lotto-nav">
                    <div
                        class="about__lotto_nav-item"
                        v-for="(nav, index) in dataConfig.nav"
                        :key="index"
                        @click="onShowDetail(nav.slug)"
                    >
                        <span class="about__lotto_nav-item-text">{{ getTranslatedText(nav?.label) }}</span>
                    </div>
                </div>
            </template>
        </template>
        <AboutSlugComponent v-else :slug="slug" />
    </div>
    <EmptyData v-else text="no data" />
</template>
<script>
import languageMixins from '@/mixins/language-mixins';
import EmptyData from '@/components/common/emptyScreen/empty.vue';
import AboutSlugComponent from '@/components/about/slug.vue';
import TitleCommon from '@/components/common/title/index.vue';

import { ABOUT_GAME_SLUG, ABOUT_LIST_SKIN, ABOUT_NAME } from '@/constants/about';
import { isArrayEmpty, isStrEmpty } from '@/utils/utils';
export default {
    mixins: [languageMixins],
    components: { EmptyData, AboutSlugComponent, TitleCommon },
    data() {
        return {
            dataConfig: null,
            ABOUT_LIST_SKIN,
            slug: '',
        };
    },
    created() {
        this.fetchData();
    },

    methods: {
        fetchData() {
            const { config } = this.$store.state;
            const index = config?.features.findIndex((x) => x.name === ABOUT_NAME);
            if (index !== -1) {
                const data = config.features[index];
                if (isStrEmpty(data?.skin)) {
                    this.slug = !isArrayEmpty(data?.nav) ? data.nav[0]?.slug : ABOUT_GAME_SLUG.LUCKY;
                }
                this.dataConfig = config.features[index];
            }
        },

        onShowDetail(slug) {
            console.log('🚀 ~ onShowDetail ~ slug:', slug);
            this.slug = slug;
        },
    },
};
</script>
